import styled from "styled-components";

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const ReceiptColumn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;

export const H2 = styled.div`
  text-align: center;
  display: flex;
  flex: 1px;
  justify-content: center;
  font-weight: bold;
  align-items: center;
`;

export const Span = styled.span`
  font-weight: bold;
  display: flex;
  flex-direction: column;
  margin-left: 40px;
`;

export const Div = styled.div`
  flex: 1px;
  padding-left: 40px;
  padding-right: 40px;
`;
